import { api } from '../../apiAxios';
import { urlHttpGov } from '../../urls';
import { getToken } from '../../LStorage/token';

class PerfilService {
    private baseURL: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' :'/gestor'}/user`;

    async getGestorUsuario(id: string | undefined, signal: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async putGestorUsuarioPerfil(
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}/profile`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PerfilService();
